import {Component, Inject, inject, Input} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from "angularx-social-login";
import { filter, map } from 'rxjs/operators';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';
import { post } from 'jquery';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {

    

    role:string = ""
    constructor(private router: Router, private authService: AuthService,
        private oktaStateService: OktaAuthStateService, @Inject(OKTA_AUTH) private oktaAuth: any
    ){

        let user:any = localStorage.getItem("user");
        if(user==null || user ==""){
            this.role = "ADMIN";
        }else{
            user = JSON.parse(user);
            this.role = user.role;
        }
    }

    

    // public isAuthenticated$ = this.oktaStateService.authState$.pipe(
    //         filter((s: AuthState) => !!s),
    //         map((s: AuthState) => s.isAuthenticated ?? false)
    //      );
       
    async signOut() {
       await this.oktaAuth.signOut({revokeAcessToken: true, revokeRefreshToken: true});
        this.router.navigate(['/extra/login']);     
     }
      

    // logoutUser(){
    //     localStorage.clear();
    //     this.authService.signOut();
    //     this.router.navigate(['/extra/login']);
    // }

   
}
